import React from 'react'

const InstantAbout = () => {
  return (
    <div>
      instant about
    </div>
  )
}

export default InstantAbout
